module.exports = __webpack_public_path__ + "static/media/back-chevron.e3d0d248.svg";